import React, { useEffect, useState } from 'react'
import { useStyles } from './styles'
import { CowFaceIcon } from 'src/assets/svg'
import { concatStyles } from 'src/utils'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import { useGetBreedList } from 'src/hooks/api/breed'
import { IAnimal } from 'src/dto/animal.dto'

interface IGenealogyCard {
  familyMember?: string
  cowSonName?: string
  data?: IAnimal
  className?: string | any
  hasParentHierarchy?: boolean
  handlerOpenParentHierarchy?: () => void
}

export const GenealogyCard = ({
  data,
  hasParentHierarchy = false,
  familyMember,
  cowSonName,
  className,
  handlerOpenParentHierarchy
}: IGenealogyCard) => {
  const [showExpandParentHierarchyButton, setShowExpandParentHierarchyButton] = useState<boolean>()
  const { data: breedList } = useGetBreedList()

  useEffect(() => {
    setShowExpandParentHierarchyButton(hasParentHierarchy)
  }, [hasParentHierarchy])

  const styles = useStyles({ sexo: data?.sexo })
  return (
    <div
      className={concatStyles(styles.cardContainer, className)}
      style={{
        borderTopColor: data?.sexo === 'F' ? '#C878CA' : data?.sexo === 'M' ? '#5778EC' : undefined
      }}
    >
      <div className={styles.cardContainerButtonContainer}>
        {showExpandParentHierarchyButton && (
          <span
            className={styles.expandButton}
            onClick={() => {
              setShowExpandParentHierarchyButton(false)
              handlerOpenParentHierarchy && handlerOpenParentHierarchy()
            }}
          >
            <ArrowUpwardIcon />
            Expandir
          </span>
        )}
        <CowFaceIcon className={styles.cardIcon} />
      </div>
      <div className={styles.cardInfoContainer}>
        <span>{data?.brinco || 'Sem indetificação'}</span>
        <span>
          {data?.raca ? breedList?.find(({ idRaca }) => idRaca === data?.raca)?.descricao || 'Sem raça' : 'Sem raça'}
        </span>
        <span>
          {familyMember && cowSonName
            ? `${familyMember} ${data?.sexo === 'M' ? 'do' : data?.sexo === 'F' ? 'da' : ''} ${cowSonName}`
            : data?.nome
              ? data?.nome
              : 'Sem nome'}
        </span>
      </div>
    </div>
  )
}
